import { createPortal } from "react-dom";

/** @param {{ visible?: boolean, target?: HTMLElement | null, children: import("react").ReactNode }} props */
const Portal = ({ visible = false, target = null, children }) => {
    const portalTarget = target ?? document.getElementById("root");

    return visible && portalTarget ? createPortal(children, portalTarget) : null;
};

export default Portal;
